/* NOV 4 2025 */
// var metafieldData = document.getElementById('metafield-container').getAttribute('data-metafield');
// var metafieldData_max = document.getElementById('metafield-container-max').getAttribute('data-metafield-max');
// const Bundles = {
//     async onLoad() {
//         this._init();
//         this.slots = [];
//     },

//     async fetchVariantData() {
//         const response = await fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
//             method: 'POST',
//             headers: {
//                 "Content-Type": "application/json"
//             },
//             body: JSON.stringify({
//                 "productPlatformId": metafieldData
//             }),
//         });
      
//         return response.json();
      
//     },

//     _productItem(product) {
//         const $template = $('.bundles__product').first().clone();
//         $template.find('.bundles__product-img').attr('src', product.imageSrc).attr('alt', product.productTitle);
//         $template.find('.bundles__product-title').text(product.productTitle);
//         $template.find('.bundles__product-vendor').text(product.vendor);
      
//         if (product.background) {
//             $template.css('background-color', product.background);
//         }

//         if (product.backgroundImage) {
//             $template.css('background-image', product.backgroundImage);
//         }

//         return $template;
//     },

//     _renderSlots() {
//         const slots = $(this.container).find('.bundles__slots');

//         slots.find('.bundles__slot').each(function () {
//         })
//     },

//     _renderProducts(products) {
//         products.forEach((productItem) => {
//             const foundObject = window.allProducts.find(obj => obj.handle === productItem.productHandle);

//             const productData = {
//                 productTitle: productItem.productTitle,
//                 handle: productItem.productHandle,
//                 imageSrc: productItem.productImageSrc,
//                 productVariant: productItem.productVariants[0].platformId
//             }

//             if (foundObject) {
//                 Object.assign(productData, foundObject);
//                 const productEl = this._productItem(productData);
//                 this.productsGrid.append(productEl);
//             }
//         })
//     },

//     _switchSize(variant) {
//         this.maxBoxAmount = +variant.data('size');

//         document.dispatchEvent(new CustomEvent("variantChanged", {
//             detail: {
//                 variantId: variant.val()
//             }
//         }));
//     },

//     _isSlotAvailable() {
//         return (this.slots.length + 1) <= this.maxBoxAmount;
//     },

//     _UIState() {
//         if (this.slots.length >= this.DynamicBox.sizeRange[0]) {
//             $(".js-add-bundles-to-cart").attr('disabled', false);

//         } else {
//             $(".js-add-bundles-to-cart").attr('disabled', true);
//         }

//         if (this.slots.length == this.maxQty) {
//             console.log(this.slots.length, 'this.slots.length');
//             console.log(this.maxQty, 'this.maxQty');
//             $(".bundles__slots-wrap").addClass('state-active');
//         } else if (this.slots.length === 0) {
//             $(".bundles__slots-wrap").removeClass('state-active');
//         }
//     },

//     _resetAll() {
//         $('.quantity-picker__inp').each(function () {
//             $(this).val(0);
//         })
//         this.slots = [];
//         this._renderSlots();
//     },

//     _slotsChecker() {
//         if (this.slots.length > this.maxBoxAmount) {
//             this._resetAll();
//         }
//     },

//     _updateProgressBar() {
//         if (!this.slots || !this.slots.length && !this.maxQty) return;
//         const stripeInner = $(".bundles__thresholds-stripe-inner");
//         const step = (100 / this.maxQty).toFixed(2);

//         const amountInPercent = this.slots.length * step;

//         $(".bundles__thresholds").find('.bundles__threshold').each((index, item) => {
//             const currentItem = $(item);
//             const currentQty = currentItem.data('threshold-qty');

//             if (currentQty) {
//                 if (currentQty <= this.slots.length) {
//                     currentItem.find('.bundles__threshold-amount').addClass('state-active');
//                 } else {
//                     currentItem.find('.bundles__threshold-amount').removeClass('state-active');
//                 }
//             }
//         })

//         if (amountInPercent <= 101) {
//             stripeInner.css('width', `${amountInPercent}%`);
//         }

//         this._UIState();
//         this._updatePrice();

//     },

//     _removeSlot(slot) {
      
//         const target = slot.find('[data-platform-id]');
//         const id = target.data('platform-id');
//         const indexToDelete = this.slots.findIndex(obj => obj.productPlatformId == id);

//         if (indexToDelete !== -1) {
           
//             this.slots.splice(indexToDelete, 1);
//             slot.html('');
//             slot.css('background', 'none');
//             slot.addClass('state-empty');

//             this._updateProgressBar();
//             this._updateSlots();
//         }
//     },

//     _updateSlots() {
//         if (!this.slots || !this.slots.length) return;
//         const slotsEl = $('.bundles__slots');
       
//         slotsEl.find('.bundles__slot').html('').addClass('state-empty');

//         this.slots.forEach((item, index) => {
//             const targetSlotItem =  slotsEl.find('.bundles__slot').eq(index);
//             const $template = $('.bundles__slot--template').first().clone();
            
//             if (targetSlotItem) {

//                 targetSlotItem.removeClass('state-empty');
//                 targetSlotItem.html('');

//                 if (item.bg.includes('linear')) {
//                     targetSlotItem.css('background-image', item.bg);
//                 } else {
//                     targetSlotItem.css('background-color', item.bg);
//                 }
             

//                 $template.attr('data-platform-id', item.productPlatformId);
//                 $template.find('img').attr('src', item.productImageSrc);
//                 targetSlotItem.prepend($template);
//             }
//         })

//         this._updateProgressBar();
//     },

//     _updateQty() {
//         this.totals.attr('data-current', this.slots.length);
//         this.totals.attr('data-total', this.maxBoxAmount);
//     },

//     _prepareItems(items) {
//         const itemMap = {};
//         items.forEach(item => {
//             const key = item.productVariants[0].platformId;

//             if (itemMap[key]) {
//                 itemMap[key].quantity += 1;
//             } else {
//                 itemMap[key] = { ...item, quantity: 1 };
//             }
//         });

//         return Object.values(itemMap)
//     },

//     _renderThresholds(thresholds) {
//         if (!thresholds) return;
//         const bundleThresholdsContainer = $('.bundles__thresholds-inner');

//         for (let key in thresholds) {
//             if (thresholds.hasOwnProperty(key)) {
//                 const step = (100 / this.maxQty).toFixed(2);
             
//                 const thresholdTemplate = `
//                 <figure class="bundles__threshold" data-threshold-qty="${key}">
//                     <div class="bundles__threshold-amount">
//                         <span data-original-price="${thresholds[key]}">-${thresholds[key]}%</span>
//                     </div>
//                 </figure>`;

//                 const $thresholdElement = $(thresholdTemplate);
//                 $thresholdElement.css('left', `${step * key}%`);

//                 bundleThresholdsContainer.append($thresholdElement);
//             }
//         }

//         bundleThresholdsContainer.append('<div class="bundles__threshold bundles__threshold--hidden"></div>');
//     },

//     _updateThresholds() {
//         const thresholds = $('.bundles__thresholds-inner').find('.bundles__threshold');

//         thresholds.each((index, item) => {
//             const currentItem = $(item);
//             const currentAmountEl = currentItem.find('.bundles__threshold-amount span');
//             const currentAmount = parseInt(currentAmountEl.data('original-price'));

//             if (this.sellingFlow == 'subscription') {
//                 currentAmountEl.text(`-${currentAmount + this.saleSubscriptionPercent}%`);
//             } else  {
//                 currentAmountEl.text(`-${currentAmount}%`);
//             }
//         })

//         this._updatePrice();
//     },

//     _renderSellingPlans() {

//         if (!this.sellingPlans) return;

//         this.sellingPlans = this.sellingPlans.sort((a, b) => a.intervalCount - b.intervalCount);

//         const targetSwitchersEl = $(".bundles__plans");
//         let counter = 0;

//         this.sellingPlans.forEach(plan => {
//             const currentPlan = plan.planId.split('/');
//             const currentPlanId = parseInt(currentPlan[currentPlan.length - 1]);

//             const switcherItemTemplate = `<label class="bundles__switcher-item"><input type="radio" ${counter == 0 ? 'checked' : ''} value="subscription" data-plan-id="${currentPlanId}" name="subscription-plan"><div class="bundles__switcher-item-label">${plan.title}</div></label>`;

//             const switcherItemEl = $(switcherItemTemplate);

//             targetSwitchersEl.append(switcherItemEl);
//             counter++;
//         })

//     },

//     _returnRelatedSkioItem(id) {
//         if (this.DynamicBox.selectableProductVariants && this.DynamicBox.selectableProductVariants.length) {
//             const skioProduct = this.DynamicBox.selectableProductVariants.find(item => {
//                 const platformId = item.productPlatformId.split('/');
//                 const currentId = parseInt(platformId[platformId.length - 1]);

//                 return currentId === id;
//             });

//             return skioProduct;
//         }
//     },

//     _addSlot(id, bg) {
//         const slotObj = this._returnRelatedSkioItem(id);

      
//         slotObj.bg = '';
//         if ((this.slots.length + 1) <= this.maxQty) {
           
//             if (slotObj && bg) {
                
//                 slotObj.bg = bg;
//                 slotObj.id = id;

//                 this.slots.push(slotObj);
//                 this._updateSlots();
//             }
//         }
//         // console.log(this.slots.length);
//     },

//     _updatePrice() {
//         const priceEl = $("#bundle-price");
//         let totalOriginalPrice = this.slots.reduce((accumulator, currentObject) => {
//             return accumulator + currentObject.productVariants[0].price;
//         }, 0);
//         const relatedDiscountPercent = this.DynamicBox.percentDiscountTier[this.slots.length] ? parseInt(this.DynamicBox.percentDiscountTier[this.slots.length]) : false;
//         let priceWithDiscount = totalOriginalPrice * (1 -relatedDiscountPercent / 100);

//         if (this.sellingFlow === 'subscription') {
//             priceWithDiscount = totalOriginalPrice * (1 - (relatedDiscountPercent + this.saleSubscriptionPercent) / 100);
//         }

//         if (relatedDiscountPercent) {
//             priceEl.text(`£${parseFloat(priceWithDiscount).toFixed(2)}`)
//             priceEl.attr('data-original-price', `£${parseFloat(totalOriginalPrice).toFixed(2)}`);
//         } else {
//             priceEl.text(`£${totalOriginalPrice}`)
//             priceEl.attr('data-original-price', ``);
//         }


//         // console.log(totalOriginalPrice, relatedDiscountPercent);
//         // this.slots.length >= this.DynamicBox.percentDiscountTier
//     },

//     _filterItemsBySellingPlans() {

//             if (this.sellingPlans) {
//                 this.productsGrid.find('.product-block').hide();

//                 this.sellingPlans.forEach((plan) => {
//                     const variants = plan.variantMapping;
//                     const currentPlan = plan.planId.split('/');
//                     const currentPlanId = parseInt(currentPlan[currentPlan.length - 1]);

//                     if (currentPlanId == this.currentSellingPlanId) {
//                         this.saleSubscriptionPercent = plan.priceAdjustmentAmount;

//                         for (const variantKey in variants) {
//                             if (variants.hasOwnProperty(variantKey)) {
//                                 const targetVariantId = variantKey.split('/');
//                                 const variantId = parseInt(targetVariantId[targetVariantId.length - 1], 10);

//                                 this.productsGrid.find(`.product-block[data-variant-id="${variantId}"]`).show();

//                             }
//                         }
//                     }
//                 })

//                 this._updateThresholds();
//             }
//     },

//     async _init() {
//         this.productsGrid = $(".bundles__parts");
//         const skioResponse = await this.fetchVariantData();
//         this.maxQty = metafieldData_max;

//         if (skioResponse.ok) {
//             this.DynamicBox = skioResponse.DynamicBox;
//             this.sellingPlans = Object.entries(this.DynamicBox.sellingPlanGroup).map(([key, value]) => ({
//                 planId: key,
//                 ...value
//               }));
            
//             this._renderSellingPlans();
//             this._renderThresholds(this.DynamicBox.percentDiscountTier);
//             this.saleSubscriptionPercent = this.sellingPlans[0].priceAdjustmentAmount;

//             // this._renderProducts(this.DynamicBox.selectableProductVariants)
//         }

//         $(".js-add-to-bundle, .product-link").on('click', (e) => {
//             e.preventDefault();

//             const currentBtn = $(e.target);
//             const currentCard = currentBtn.closest('.product-block');
//             const styleAttr = currentCard.attr('style');
             

//             if (styleAttr) {
//                 // Try to match background-color first
//                 let bgColorMatch = styleAttr.match(/background-color\s*:\s*([^;]+);?/i);

//                 if (bgColorMatch && bgColorMatch[1]) {
//                     var bgColor = bgColorMatch[1].trim();
                
//                 } else {
//                     let bgMatch = styleAttr.match(/background\s*:\s*([^;!]+)(?:!important)?;?/i);

//                     if (bgMatch && bgMatch[1]) {
//                         var bgColor = bgMatch[1].trim();
                    
//                     } else {
//                  var bgColor = currentCard.css('background').includes('linear') ? currentCard.css('background') : currentCard.css('background-color');
//                     }
//                 }
//             }    
    

//             this._addSlot(currentCard.data('product-id'), bgColor);
//         })

//         $(".bundles__select").on('change', function (e) {
//             e.preventDefault();
//             const currentBtn = $(this);
//             const targetContent = $(currentBtn).closest('.bundles').find(".bundles__parts");

//             targetContent.find('.bundles__part').hide();
//             targetContent.find(`${currentBtn.val()}`).fadeIn();
//         })

//         $(".bundles__nav").on('click', "a", function (e) {
//             e.preventDefault();
//             const currentBtn = $(this);
//             const currentVal = currentBtn.attr('href');
//             const targetContent = $(currentBtn).closest('.bundles').find(".bundles__parts");

//             currentBtn.closest('ul').find('a.active').removeClass('active');
//             currentBtn.addClass('active');

//             if (currentVal.includes('all')) {
//                 targetContent.find('.bundles__part').fadeIn();
//             } else {
//                 targetContent.find('.bundles__part').hide();
//                 targetContent.find(`${currentBtn.attr('href')}`).fadeIn();
//             }
//         })

//         $(".bundles__slot").on('click', (e) => {
//             const currentSlot = $(e.target);
//             this._removeSlot(currentSlot);
//         })

//         $(".bundles__main-header").on('click', function (e) {
//             e.preventDefault();
//             const currentBtn = $(this);
//             currentBtn.toggleClass('state-active');
//             $(".bundles__slots-wrap").toggleClass('state-active');
//         })

//         $('[name="subscription-plan"]').on('change', (e) => {
//             this.currentSellingPlan = $(e.target).val();
//             this.currentSellingPlanId = $(e.target).data('plan-id');
//             this._filterItemsBySellingPlans(this.currentSellingPlan);
//         })

//         if ($('[name="subscription-plan"]:checked').length) {
//             const sellingPlanId = $('[name="subscription-plan"]:checked').data('plan-id');
//             this.currentSellingPlanId = sellingPlanId;
//         }

//         $('[name="selling-plan"]').on('change', (e) => {
//             this.sellingFlow = $(e.target).val();
//             this._updateThresholds();

//             if (this.sellingFlow === 'subscription') {
//                 $(".bundles__plans").addClass('state-active')
//             } else {
//                 $(".bundles__plans").removeClass('state-active')
//             }
//         })

//         $('.js-add-bundles-to-cart').on('click', (e)=> {
//             const sellingPlanId = this.sellingFlow === 'subscription' ? this.currentSellingPlanId : '';

//             const items = [
//                 // {
//                 //     ...(sellingPlanId && { selling_plan: sellingPlanId }),
//                 //     properties: {}
//                 // }
//             ];

//             const preparedItems = this._prepareItems(this.slots);

//             if (!preparedItems.length) return;

//             preparedItems.forEach((box, index) => {
//                 const parts = box.productVariants[0].platformId.split('/');
//                 const activeVariantId = parts[parts.length - 1];
//                 const obj = {
//                     // selling_plan: 21184512036,
//                     selling_plan: sellingPlanId,
//                     properties: {}
//                 }

//                 obj.id = activeVariantId;
//                 obj.quantity = box.quantity;
//                 obj.properties['_dynamicBoxIndex'] = 0;
//                 obj.properties['_dynamicBoxId'] = this.DynamicBox.boxId;
                
//                 items.push(obj);
//             })
//             // console.log(items, preparedItems);

//             const baseUrl = `${Shopify.routes.root}cart/clear?return_to=/cart/add?`;
//             const returnPath = "%26return_to=/checkout";

//             let itemParams = '';
//             console.log(items);

//             items.forEach((item, index) => {
//                 itemParams += `%26items[${index}][quantity]=${item.quantity}%26items[${index}][selling_plan]=${item.selling_plan}%26items[${index}][id]=${item.id}%26items[${index}][properties][_dynamicBoxId]=${item.properties._dynamicBoxId}%26items[${index}][properties][_dynamicBoxIndex]=0`;
//             })


//             const magicLink = `${baseUrl}${itemParams}${returnPath}`;

//             console.log(magicLink);

//             window.location.href = magicLink;

//             // fetch('/cart/add.js', {
//             //     method: 'POST',
//             //     headers: {
//             //         'Content-Type': 'application/json'
//             //     },
//             //     body: JSON.stringify({ items })
//             // })
//             //     .then(response => response.json())
//             //     .then(response => {
//             //         console.log(response);
//             //         // console.log(`SKIO added item to cart: ${response.items[0].product_title} x ${quantity}`);
//             //     })
//             //     .catch(error => {
//             //         console.error("SKIO error adding item to cart: ", error);
//             //     });
//         });

//     },
// };

// export default Bundles;

// $(".bundles.template-collection .tabs.bundles__nav li a").click(function(e) {
// var hrefdata = $(this).attr("href"); 
// var currentUrl = window.location.href.split('#')[0]; 
// var finalurl = currentUrl + hrefdata;
// history.pushState(null, '', finalurl);
// });





/* tested code*/
// var metafieldData = document.getElementById('metafield-container').getAttribute('data-metafield');
// var metafieldData_max = document.getElementById('metafield-container-max').getAttribute('data-metafield-max');

// const Bundles = {
//     async onLoad() {
//         this._init();
//         this.slots = [];
//     },

//     async fetchVariantData() {
//         const response = await fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
//             method: 'POST',
//             headers: {
//                 "Content-Type": "application/json"
//             },
//             body: JSON.stringify({
//                 "productPlatformId": metafieldData
//             }),
//         });
//         return response.json();
//     },

//     _productItem(product) {
//         const $template = $('.bundles__product').first().clone();
//         $template.find('.bundles__product-img').attr('src', product.imageSrc).attr('alt', product.productTitle);
//         $template.find('.bundles__product-title').text(product.productTitle);
//         $template.find('.bundles__product-vendor').text(product.vendor);

//         if (product.background) {
//             $template.css('background-color', product.background);
//         }

//         if (product.backgroundImage) {
//             $template.css('background-image', product.backgroundImage);
//         }

//         return $template;
//     },

//     _renderSlots() {
//         const slots = $(this.container).find('.bundles__slots');
//         slots.find('.bundles__slot').each(function () {})
//     },

//     _renderProducts(products) {
//         products.forEach((productItem) => {
//             const foundObject = window.allProducts.find(obj => obj.handle === productItem.productHandle);

//             const productData = {
//                 productTitle: productItem.productTitle,
//                 handle: productItem.productHandle,
//                 imageSrc: productItem.productImageSrc,
//                 productVariant: productItem.productVariants[0].platformId
//             }

//             if (foundObject) {
//                 Object.assign(productData, foundObject);
//                 const productEl = this._productItem(productData);
//                 this.productsGrid.append(productEl);
//             }
//         })
//     },

//     _switchSize(variant) {
//         this.maxBoxAmount = +variant.data('size');
//         document.dispatchEvent(new CustomEvent("variantChanged", {
//             detail: {
//                 variantId: variant.val()
//             }
//         }));
//     },

//     _isSlotAvailable() {
//         return (this.slots.length + 1) <= this.maxBoxAmount;
//     },

//     _UIState() {
//         if (this.slots.length >= this.DynamicBox.sizeRange[0]) {
//             $(".js-add-bundles-to-cart").attr('disabled', false);
//         } else {
//             $(".js-add-bundles-to-cart").attr('disabled', true);
//         }

//         if (this.slots.length == this.maxQty) {
//             $(".bundles__slots-wrap").addClass('state-active');
//         } else if (this.slots.length === 0) {
//             $(".bundles__slots-wrap").removeClass('state-active');
//         }
//     },

//     _resetAll() {
//         $('.quantity-picker__inp').each(function () {
//             $(this).val(0);
//         })
//         this.slots = [];
//         this._renderSlots();
//     },

//     _slotsChecker() {
//         if (this.slots.length > this.maxBoxAmount) {
//             this._resetAll();
//         }
//     },

//     _updateProgressBar() {
//         if (!this.slots || !this.slots.length && !this.maxQty) return;
//         const stripeInner = $(".bundles__thresholds-stripe-inner");
//         const step = (100 / this.maxQty).toFixed(2);
//         const amountInPercent = this.slots.length * step;

//         $(".bundles__thresholds").find('.bundles__threshold').each((index, item) => {
//             const currentItem = $(item);
//             const currentQty = currentItem.data('threshold-qty');

//             if (currentQty) {
//                 if (currentQty <= this.slots.length) {
//                     currentItem.find('.bundles__threshold-amount').addClass('state-active');
//                 } else {
//                     currentItem.find('.bundles__threshold-amount').removeClass('state-active');
//                 }
//             }
//         })

//         if (amountInPercent <= 101) {
//             stripeInner.css('width', `${amountInPercent}%`);
//         }

//         this._UIState();
//         this._updatePrice();
//     },

// _removeSlot(slot) {
//     const target = slot.find('[data-platform-id]');
//     const id = target.data('platform-id');
//     const indexToDelete = this.slots.findIndex(obj => obj.productPlatformId == id);

//     if (indexToDelete !== -1) {
//         this.slots.splice(indexToDelete, 1);
//         slot.html('');
//         slot.css('background', 'none');
//         slot.addClass('state-empty');

//         this._updateProgressBar();
//         this._updateSlots(); 
//     }
// },


//     _updateSlots() {
//     if (!this.slots || !this.slots.length) return;
//     const slotsEl = $('.bundles__slots');
//     const allSlots = slotsEl.find('.bundles__slot');


//     allSlots.css({
//         'background': 'none',
//         'background-image': 'none',
//         'background-color': 'transparent'
//     });


//     slotsEl.find('.bundles__slot').html('').addClass('state-empty');

//     this.slots.forEach((item, index) => {
//         const targetSlotItem = slotsEl.find('.bundles__slot').eq(index);
//         const $template = $('.bundles__slot--template').first().clone();
        
//         if (targetSlotItem) {
//             targetSlotItem.removeClass('state-empty');
//             targetSlotItem.html('');

//             if (item.bg.includes('linear')) {
//                 targetSlotItem.css('background-image', item.bg);
//             } else {
//                 targetSlotItem.css('background-color', item.bg);
//             }

//             $template.attr('data-platform-id', item.productPlatformId);
//             $template.find('img').attr('src', item.productImageSrc);
//             targetSlotItem.prepend($template);
//         }
//     })

//     this._updateProgressBar();
// },

//     _updateQty() {
//         this.totals.attr('data-current', this.slots.length);
//         this.totals.attr('data-total', this.maxBoxAmount);
//     },

//     _prepareItems(items) {
//         const itemMap = {};
//         items.forEach(item => {
//             const key = item.productVariants[0].platformId;
//             if (itemMap[key]) {
//                 itemMap[key].quantity += 1;
//             } else {
//                 itemMap[key] = { ...item, quantity: 1 };
//             }
//         });
//         return Object.values(itemMap)
//     },

//     _renderThresholds(thresholds) {
//         if (!thresholds) return;
//         const bundleThresholdsContainer = $('.bundles__thresholds-inner');

//         for (let key in thresholds) {
//             if (thresholds.hasOwnProperty(key)) {
//                 const step = (100 / this.maxQty).toFixed(2);
//                 const thresholdTemplate = `
//                 <figure class="bundles__threshold" data-threshold-qty="${key}">
//                     <div class="bundles__threshold-amount">
//                         <span data-original-price="${thresholds[key]}">-${thresholds[key]}%</span>
//                     </div>
//                 </figure>`;
//                 const $thresholdElement = $(thresholdTemplate);
//                 $thresholdElement.css('left', `${step * key}%`);
//                 bundleThresholdsContainer.append($thresholdElement);
//             }
//         }
//         bundleThresholdsContainer.append('<div class="bundles__threshold bundles__threshold--hidden"></div>');
//     },

//     _updateThresholds() {
//         const thresholds = $('.bundles__thresholds-inner').find('.bundles__threshold');
//         thresholds.each((index, item) => {
//             const currentItem = $(item);
//             const currentAmountEl = currentItem.find('.bundles__threshold-amount span');
//             const currentAmount = parseInt(currentAmountEl.data('original-price'));

//             if (this.sellingFlow == 'subscription') {
//                 currentAmountEl.text(`-${currentAmount + this.saleSubscriptionPercent}%`);
//             } else {
//                 currentAmountEl.text(`-${currentAmount}%`);
//             }
//         })
//         this._updatePrice();
//     },

//     _renderSellingPlans() {
//         if (!this.sellingPlans) return;
//         this.sellingPlans = this.sellingPlans.sort((a, b) => a.intervalCount - b.intervalCount);
//         const targetSwitchersEl = $(".bundles__plans");
//         let counter = 0;

//         this.sellingPlans.forEach(plan => {
//             const currentPlan = plan.planId.split('/');
//             const currentPlanId = parseInt(currentPlan[currentPlan.length - 1]);
//             const switcherItemTemplate = `<label class="bundles__switcher-item"><input type="radio" ${counter == 0 ? 'checked' : ''} value="subscription" data-plan-id="${currentPlanId}" name="subscription-plan"><div class="bundles__switcher-item-label">${plan.title}</div></label>`;
//             const switcherItemEl = $(switcherItemTemplate);
//             targetSwitchersEl.append(switcherItemEl);
//             counter++;
//         })
//     },

//     _returnRelatedSkioItem(id) {
//         if (this.DynamicBox.selectableProductVariants && this.DynamicBox.selectableProductVariants.length) {
//             const skioProduct = this.DynamicBox.selectableProductVariants.find(item => {
//                 const platformId = item.productPlatformId.split('/');
//                 const currentId = parseInt(platformId[platformId.length - 1]);
//                 return currentId === id;
//             });
//             return skioProduct;
//         }
//     },

//     _addSlot(id, bg) {
//         const slotObj = this._returnRelatedSkioItem(id);
//         if ((this.slots.length + 1) <= this.maxQty) {
//             if (slotObj && bg) {
//                 slotObj.bg = bg;
//                 slotObj.id = id;
//                 this.slots.push(slotObj);
//                 this._updateSlots();
//             }
//         }
//     },

//     _updatePrice() {
//         const priceEl = $("#bundle-price");
//         let totalOriginalPrice = this.slots.reduce((accumulator, currentObject) => {
//             return accumulator + currentObject.productVariants[0].price;
//         }, 0);
//         const relatedDiscountPercent = this.DynamicBox.percentDiscountTier[this.slots.length] ? parseInt(this.DynamicBox.percentDiscountTier[this.slots.length]) : false;
//         let priceWithDiscount = totalOriginalPrice * (1 - relatedDiscountPercent / 100);

//         if (this.sellingFlow === 'subscription') {
//             priceWithDiscount = totalOriginalPrice * (1 - (relatedDiscountPercent + this.saleSubscriptionPercent) / 100);
//         }

//         if (relatedDiscountPercent) {
//             priceEl.text(`£${parseFloat(priceWithDiscount).toFixed(2)}`)
//             priceEl.attr('data-original-price', `£${parseFloat(totalOriginalPrice).toFixed(2)}`);
//         } else {
//             priceEl.text(`£${totalOriginalPrice}`)
//             priceEl.attr('data-original-price', ``);
//         }
//     },

//     _filterItemsBySellingPlans() {
//         if (this.sellingPlans) {
//             this.productsGrid.find('.product-block').hide();
//             this.sellingPlans.forEach((plan) => {
//                 const variants = plan.variantMapping;
//                 const currentPlan = plan.planId.split('/');
//                 const currentPlanId = parseInt(currentPlan[currentPlan.length - 1]);

//                 if (currentPlanId == this.currentSellingPlanId) {
//                     this.saleSubscriptionPercent = plan.priceAdjustmentAmount;
//                     for (const variantKey in variants) {
//                         if (variants.hasOwnProperty(variantKey)) {
//                             const targetVariantId = variantKey.split('/');
//                             const variantId = parseInt(targetVariantId[targetVariantId.length - 1], 10);
//                             this.productsGrid.find(`.product-block[data-variant-id="${variantId}"]`).show();
//                         }
//                     }
//                 }
//             })
//             this._updateThresholds();
//         }
//     },

//     async _init() {
//         this.productsGrid = $(".bundles__parts");
//         const skioResponse = await this.fetchVariantData();
//         this.maxQty = metafieldData_max;

//         if (skioResponse.ok) {
//             this.DynamicBox = skioResponse.DynamicBox;
//             this.sellingPlans = Object.entries(this.DynamicBox.sellingPlanGroup).map(([key, value]) => ({
//                 planId: key,
//                 ...value
//             }));
//             this._renderSellingPlans();
//             this._renderThresholds(this.DynamicBox.percentDiscountTier);
//             this.saleSubscriptionPercent = this.sellingPlans[0].priceAdjustmentAmount;
//         }


//         $(".js-add-to-bundle, .product-link").on('click', (e) => {
//             e.preventDefault();
//             const currentCard = $(e.target).closest('.product-block');
//             let bgColor = '';
//             const styleAttr = currentCard.attr('style') || '';

//             const gradMatch = styleAttr.match(/background-image\s*:\s*(linear-gradient\([^;]+\))/i);
//             if (gradMatch) {
//                 bgColor = gradMatch[1];
//             } else {
//                 const colorMatch = styleAttr.match(/background-color\s*:\s*([^;]+)/i);
//                 if (colorMatch) {
//                     bgColor = colorMatch[1].trim();
//                 } else {
//                     const bgMatch = styleAttr.match(/background\s*:\s*([^;]+)/i);
//                     if (bgMatch) {
//                         bgColor = bgMatch[1].trim();
//                     } else {
//                         const computed = currentCard.css('background');
//                         bgColor = computed && computed.includes('gradient') 
//                             ? currentCard.css('background-image') 
//                             : currentCard.css('background-color');
//                     }
//                 }
//             }

//             const productId = currentCard.data('product-id');
//             this._addSlot(productId, bgColor);
//         })

//         $(".bundles__select").on('change', function (e) {
//             e.preventDefault();
//             const currentBtn = $(this);
//             const targetContent = $(currentBtn).closest('.bundles').find(".bundles__parts");
//             targetContent.find('.bundles__part').hide();
//             targetContent.find(`${currentBtn.val()}`).fadeIn();
//         })

//         $(".bundles__nav").on('click', "a", function (e) {
//             e.preventDefault();
//             const currentBtn = $(this);
//             const currentVal = currentBtn.attr('href');
//             const targetContent = $(currentBtn).closest('.bundles').find(".bundles__parts");
//             currentBtn.closest('ul').find('a.active').removeClass('active');
//             currentBtn.addClass('active');
//             if (currentVal.includes('all')) {
//                 targetContent.find('.bundles__part').fadeIn();
//             } else {
//                 targetContent.find('.bundles__part').hide();
//                 targetContent.find(`${currentBtn.attr('href')}`).fadeIn();
//             }
//         })

//         $(".bundles__slot").on('click', (e) => {
//             this._removeSlot($(e.target));
//         })

//         $(".bundles__main-header").on('click', function (e) {
//             e.preventDefault();
//             const currentBtn = $(this);
//             currentBtn.toggleClass('state-active');
//             $(".bundles__slots-wrap").toggleClass('state-active');
//         })

//         $('[name="subscription-plan"]').on('change', (e) => {
//             this.currentSellingPlan = $(e.target).val();
//             this.currentSellingPlanId = $(e.target).data('plan-id');
//             this._filterItemsBySellingPlans(this.currentSellingPlan);
//         })

//         if ($('[name="subscription-plan"]:checked').length) {
//             const sellingPlanId = $('[name="subscription-plan"]:checked').data('plan-id');
//             this.currentSellingPlanId = sellingPlanId;
//         }

//         $('[name="selling-plan"]').on('change', (e) => {
//             this.sellingFlow = $(e.target).val();
//             this._updateThresholds();
//             if (this.sellingFlow === 'subscription') {
//                 $(".bundles__plans").addClass('state-active')
//             } else {
//                 $(".bundles__plans").removeClass('state-active')
//             }
//         })

//         $('.js-add-bundles-to-cart').on('click', (e)=> {
//             const sellingPlanId = this.sellingFlow === 'subscription' ? this.currentSellingPlanId : '';
//             const items = [];
//             const preparedItems = this._prepareItems(this.slots);

//             if (!preparedItems.length) return;

//             preparedItems.forEach((box, index) => {
//                 const parts = box.productVariants[0].platformId.split('/');
//                 const activeVariantId = parts[parts.length - 1];
//                 const obj = {
//                     selling_plan: sellingPlanId,
//                     properties: {}
//                 }
//                 obj.id = activeVariantId;
//                 obj.quantity = box.quantity;
//                 obj.properties['_dynamicBoxIndex'] = 0;
//                 obj.properties['_dynamicBoxId'] = this.DynamicBox.boxId;
//                 items.push(obj);
//             })

//             const baseUrl = `${Shopify.routes.root}cart/clear?return_to=/cart/add?`;
//             const returnPath = "%26return_to=/checkout";
//             let itemParams = '';

//             items.forEach((item, index) => {
//                 itemParams += `%26items[${index}][quantity]=${item.quantity}%26items[${index}][selling_plan]=${item.selling_plan}%26items[${index}][id]=${item.id}%26items[${index}][properties][_dynamicBoxId]=${item.properties._dynamicBoxId}%26items[${index}][properties][_dynamicBoxIndex]=0`;
//             })

//             const magicLink = `${baseUrl}${itemParams}${returnPath}`;
//             window.location.href = magicLink;
//         });
//     },
// };

// export default Bundles;

// $(".bundles.template-collection .tabs.bundles__nav li a").click(function(e) {
//     var hrefdata = $(this).attr("href"); 
//     var currentUrl = window.location.href.split('#')[0]; 
//     var finalurl = currentUrl + hrefdata;
//     history.pushState(null, '', finalurl);
// });



/* tested-2 */
var metafieldData = document.getElementById('metafield-container').getAttribute('data-metafield');
var metafieldData_max = document.getElementById('metafield-container-max').getAttribute('data-metafield-max');

console.log("Metafield data:", metafieldData);
console.log("Metafield max:", metafieldData_max);

const Bundles = {
    async onLoad() {
        console.log("Bundles.onLoad() called");
        this._init();
        this.slots = [];
    },

    async fetchVariantData() {
        console.log("Fetching variant data from Skio API...");
        const response = await fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "productPlatformId": metafieldData
            }),
        });
        console.log("Response received from Skio:", response);
        return response.json();
    },

    _productItem(product) {
        console.log("Rendering product item:", product);
        const $template = $('.bundles__product').first().clone();
        $template.find('.bundles__product-img').attr('src', product.imageSrc).attr('alt', product.productTitle);
        $template.find('.bundles__product-title').text(product.productTitle);
        $template.find('.bundles__product-vendor').text(product.vendor);

        if (product.background) {
            $template.css('background-color', product.background);
        }

        if (product.backgroundImage) {
            $template.css('background-image', product.backgroundImage);
        }

        return $template;
    },

    _renderSlots() {
        console.log("Rendering slots...");
        const slots = $(this.container).find('.bundles__slots');
        slots.find('.bundles__slot').each(function () {
            console.log("Found slot element:", this);
        })
    },

    _renderProducts(products) {
        console.log("Rendering products:", products);
        products.forEach((productItem) => {
            const foundObject = window.allProducts.find(obj => obj.handle === productItem.productHandle);
            console.log("Found matching product object:", foundObject);

            const productData = {
                productTitle: productItem.productTitle,
                handle: productItem.productHandle,
                imageSrc: productItem.productImageSrc,
                productVariant: productItem.productVariants[0].platformId
            }

            if (foundObject) {
                Object.assign(productData, foundObject);
                const productEl = this._productItem(productData);
                this.productsGrid.append(productEl);
                console.log("Product rendered to grid:", productData);
            }
        })
    },

    _switchSize(variant) {
        console.log("Switching bundle size. Variant:", variant);
        this.maxBoxAmount = +variant.data('size');
        document.dispatchEvent(new CustomEvent("variantChanged", {
            detail: {
                variantId: variant.val()
            }
        }));
    },

    _isSlotAvailable() {
        const result = (this.slots.length + 1) <= this.maxBoxAmount;
        console.log("Checking if slot available:", result);
        return result;
    },

    _UIState() {
        console.log("Updating UI state...");
        if (this.slots.length >= this.DynamicBox.sizeRange[0]) {
            $(".js-add-bundles-to-cart").attr('disabled', false);
        } else {
            $(".js-add-bundles-to-cart").attr('disabled', true);
        }

        if (this.slots.length == this.maxQty) {
            $(".bundles__slots-wrap").addClass('state-active');
        } else if (this.slots.length === 0) {
            $(".bundles__slots-wrap").removeClass('state-active');
        }

        console.log("UI state updated. Slots:", this.slots.length, "/", this.maxQty);
    },

    _resetAll() {
        console.log("Resetting all slots and quantities...");
        $('.quantity-picker__inp').each(function () {
            $(this).val(0);
        })
        this.slots = [];
        this._renderSlots();
    },

    _slotsChecker() {
        console.log("Checking slot count...");
        if (this.slots.length > this.maxBoxAmount) {
            console.warn("Too many slots! Resetting...");
            this._resetAll();
        }
    },

    _updateProgressBar() {
        console.log("Updating progress bar...");
        if (!this.slots || !this.slots.length && !this.maxQty) return;
        const stripeInner = $(".bundles__thresholds-stripe-inner");
        const step = (100 / this.maxQty).toFixed(2);
        const amountInPercent = this.slots.length * step;
        console.log(`Progress: ${this.slots.length}/${this.maxQty} (${amountInPercent}%)`);

        $(".bundles__thresholds").find('.bundles__threshold').each((index, item) => {
            const currentItem = $(item);
            const currentQty = currentItem.data('threshold-qty');
            if (currentQty) {
                if (currentQty <= this.slots.length) {
                    currentItem.find('.bundles__threshold-amount').addClass('state-active');
                } else {
                    currentItem.find('.bundles__threshold-amount').removeClass('state-active');
                }
            }
        })

        if (amountInPercent <= 101) {
            stripeInner.css('width', `${amountInPercent}%`);
        }

        this._UIState();
        this._updatePrice();
    },

    _removeSlot(slot) {
        console.log("Removing slot:", slot);
        const target = slot.find('[data-platform-id]');
        const id = target.data('platform-id');
        const indexToDelete = this.slots.findIndex(obj => obj.productPlatformId == id);

        if (indexToDelete !== -1) {
            console.log("Slot removed:", id);
            this.slots.splice(indexToDelete, 1);
            slot.html('');
            slot.css('background', 'none');
            slot.addClass('state-empty');

            this._updateProgressBar();
            this._updateSlots();
        }
    },

    /* --------------------------------------------------------------
       ONLY THIS METHOD WAS CHANGED – slot size is now guaranteed
       -------------------------------------------------------------- */
    // _updateSlots() {
    //     console.log("Updating slot visuals...");
    //     const slotsEl   = $('.bundles__slots');
    //     const allSlots  = slotsEl.find('.bundles__slot');

    //     allSlots
    //         .css({ background: 'none', 'background-image': 'none', 'background-color': 'transparent' })
    //         .html('')
    //         .addClass('state-empty');

    //     if (!this.slots || !this.slots.length) {
    //         this._updateProgressBar();
    //         return;
    //     }


    //     this.slots.forEach((item, idx) => {
    //         const $slot = allSlots.eq(idx);
    //         console.log('----item----',item);


    //         window.productSlots.forEach(item => {
    //             const imgSrc = item.metafields?.custom?.extra_collection_small_image || item.productImageSrc;
    //             console.log(imgSrc + " ===== " + item.productPlatformId);
    //         });


    //         if (!$slot.length) return;

    //         $slot.removeClass('state-empty');

    //         // background (gradient or solid)
    //         if (item.bg) {
    //             if (item.bg.includes('linear-gradient')) {
    //                 $slot.css('background-image', item.bg);
    //             } else {
    //                 $slot.css('background-color', item.bg);
    //             }
    //         }

    //         // clone the hidden template
    //         const $tpl   = $('.bundles__slot--template').first().clone();
    //         const imgSrc = this.overrideSlotImage || item.productImageSrc || '';

    //         $tpl.find('img').attr('src', imgSrc);
    //         $tpl.attr('data-platform-id', item.productPlatformId);

    //         // insert – exactly ONE child
    //         $slot.html($tpl);
    //     });

    //     this._updateProgressBar();
    // },


        _updateSlots() {
            console.log("Updating slot visuals...");
            const slotsEl  = $('.bundles__slots');
            const allSlots = slotsEl.find('.bundles__slot');
            allSlots
                .css({ background: 'none', 'background-image': 'none', 'background-color': 'transparent' })
                .html('')
                .addClass('state-empty');
            if (!this.slots || !this.slots.length) {
                this._updateProgressBar();
                return;
            }
            this.slots.forEach((item, idx) => {
                const $slot = allSlots.eq(idx);
                if (!$slot.length) return;
                $slot.removeClass('state-empty');
                if (item.bg) {
                    if (item.bg.includes('linear-gradient')) {
                        $slot.css('background-image', item.bg);
                    } else {
                        $slot.css('background-color', item.bg);
                    }
                }
                const $tpl = $('.bundles__slot--template').first().clone();
                let imgSrc = this.overrideSlotImage || item.productImageSrc || '';
                const matchingProduct = window.productSlots?.find(p => p.productPlatformId === item.id);
                if (matchingProduct) {
                    const metaImg = matchingProduct.metafields?.custom?.extra_collection_small_image;
                    if (metaImg && metaImg.trim() !== '') {
                        imgSrc = metaImg;
                    }
                }
                $tpl.find('img').attr('src', imgSrc);
                $tpl.attr('data-platform-id', item.productPlatformId);
                $slot.html($tpl);
                console.log(`Slot ${idx} - Platform ID: ${item.id}, Image used: ${imgSrc}`);
            });
            this._updateProgressBar();
        },

    _updateQty() {
        console.log("Updating quantity display...");
        this.totals.attr('data-current', this.slots.length);
        this.totals.attr('data-total', this.maxBoxAmount);
    },

    _prepareItems(items) {
        console.log("Preparing items for checkout:", items);
        const itemMap = {};
        items.forEach(item => {
            const key = item.productVariants[0].platformId;
            if (itemMap[key]) {
                itemMap[key].quantity += 1;
            } else {
                itemMap[key] = { ...item, quantity: 1 };
            }
        });
        const prepared = Object.values(itemMap);
        console.log("Prepared items:", prepared);
        return prepared;
    },

    _renderThresholds(thresholds) {
        console.log("Rendering thresholds:", thresholds);
        if (!thresholds) return;
        const bundleThresholdsContainer = $('.bundles__thresholds-inner');

        for (let key in thresholds) {
            if (thresholds.hasOwnProperty(key)) {
                const step = (100 / this.maxQty).toFixed(2);
                const thresholdTemplate = `
                <figure class="bundles__threshold" data-threshold-qty="${key}">
                    <div class="bundles__threshold-amount">
                        <span data-original-price="${thresholds[key]}">-${thresholds[key]}%</span>
                    </div>
                </figure>`;
                const $thresholdElement = $(thresholdTemplate);
                $thresholdElement.css('left', `${step * key}%`);
                bundleThresholdsContainer.append($thresholdElement);
            }
        }
        bundleThresholdsContainer.append('<div class="bundles__threshold bundles__threshold--hidden"></div>');
    },

    _updateThresholds() {
        console.log("Updating thresholds...");
        const thresholds = $('.bundles__thresholds-inner').find('.bundles__threshold');
        thresholds.each((index, item) => {
            const currentItem = $(item);
            const currentAmountEl = currentItem.find('.bundles__threshold-amount span');
            const currentAmount = parseInt(currentAmountEl.data('original-price'));

            if (this.sellingFlow == 'subscription') {
                currentAmountEl.text(`-${currentAmount + this.saleSubscriptionPercent}%`);
            } else {
                currentAmountEl.text(`-${currentAmount}%`);
            }
        })
        this._updatePrice();
    },

    _renderSellingPlans() {
        console.log("Rendering selling plans...");
        if (!this.sellingPlans) return;
        this.sellingPlans = this.sellingPlans.sort((a, b) => a.intervalCount - b.intervalCount);
        const targetSwitchersEl = $(".bundles__plans");
        let counter = 0;

        this.sellingPlans.forEach(plan => {
            const currentPlan = plan.planId.split('/');
            const currentPlanId = parseInt(currentPlan[currentPlan.length - 1]);
            const switcherItemTemplate = `<label class="bundles__switcher-item"><input type="radio" ${counter == 0 ? 'checked' : ''} value="subscription" data-plan-id="${currentPlanId}" name="subscription-plan"><div class="bundles__switcher-item-label">${plan.title}</div></label>`;
            const switcherItemEl = $(switcherItemTemplate);
            targetSwitchersEl.append(switcherItemEl);
            counter++;
        })
    },

    _returnRelatedSkioItem(id) {
        console.log("Getting related SKIO item for id:", id);
        if (this.DynamicBox.selectableProductVariants && this.DynamicBox.selectableProductVariants.length) {
            const skioProduct = this.DynamicBox.selectableProductVariants.find(item => {
                const platformId = item.productPlatformId.split('/');
                const currentId = parseInt(platformId[platformId.length - 1]);
                return currentId === id;
            });
            console.log("Found SKIO product:", skioProduct);
            return skioProduct;
        }
    },

    _addSlot(id, bg) {
        console.log("Adding slot:", id, "with bg:", bg);
        const slotObj = this._returnRelatedSkioItem(id);
        if ((this.slots.length + 1) <= this.maxQty) {
            if (slotObj && bg) {
                slotObj.bg = bg;
                slotObj.id = id;

                if (this.overrideSlotImage) {
                    slotObj.productImageSrc = this.overrideSlotImage;
                }

                this.slots.push(slotObj);
                console.log("Slot added. Current slots:", this.slots);
                this._updateSlots();
            }
        }
    },

    _updatePrice() {
        console.log("Updating price...");
        const priceEl = $("#bundle-price");
        let totalOriginalPrice = this.slots.reduce((accumulator, currentObject) => {
            return accumulator + currentObject.productVariants[0].price;
        }, 0);
        const relatedDiscountPercent = this.DynamicBox.percentDiscountTier[this.slots.length] ? parseInt(this.DynamicBox.percentDiscountTier[this.slots.length]) : false;
        let priceWithDiscount = totalOriginalPrice * (1 - relatedDiscountPercent / 100);

        if (this.sellingFlow === 'subscription') {
            priceWithDiscount = totalOriginalPrice * (1 - (relatedDiscountPercent + this.saleSubscriptionPercent) / 100);
        }

        if (relatedDiscountPercent) {
            priceEl.text(`£${parseFloat(priceWithDiscount).toFixed(2)}`)
            priceEl.attr('data-original-price', `£${parseFloat(totalOriginalPrice).toFixed(2)}`);
        } else {
            priceEl.text(`£${totalOriginalPrice}`)
            priceEl.attr('data-original-price', ``);
        }
        console.log("Price updated:", priceEl.text());
    },

    _filterItemsBySellingPlans() {
        console.log("Filtering items by selling plans...");
        if (this.sellingPlans) {
            this.productsGrid.find('.product-block').hide();
            this.sellingPlans.forEach((plan) => {
                const variants = plan.variantMapping;
                const currentPlan = plan.planId.split('/');
                const currentPlanId = parseInt(currentPlan[currentPlan.length - 1]);

                if (currentPlanId == this.currentSellingPlanId) {
                    this.saleSubscriptionPercent = plan.priceAdjustmentAmount;
                    for (const variantKey in variants) {
                        if (variants.hasOwnProperty(variantKey)) {
                            const targetVariantId = variantKey.split('/');
                            const variantId = parseInt(targetVariantId[targetVariantId.length - 1], 10);
                            this.productsGrid.find(`.product-block[data-variant-id="${variantId}"]`).show();
                        }
                    }
                }
            })
            this._updateThresholds();
        }
    },

    async _init() {
        console.log("Initializing Bundles...");
        this.productsGrid = $(".bundles__parts");
        const skioResponse = await this.fetchVariantData();
        console.log("SKIO Response JSON:", skioResponse);
        this.maxQty = metafieldData_max;

        let metafieldImage = null;
        try {
            const productData = JSON.parse(metafieldData);
            console.log("Parsed metafieldData:", productData);
            if (productData?.metafields?.custom?.extra_collection_small_image?.value) {
                metafieldImage = productData.metafields.custom.extra_collection_small_image.value;
            }
        } catch (e) {
            console.warn("Failed to parse metafieldData for extra_collection_small_image", e);
        }
        this.overrideSlotImage = metafieldImage;
        console.log("Override slot image set to:", this.overrideSlotImage);

        if (skioResponse.ok) {
            console.log("SKIO DynamicBox loaded:", skioResponse.DynamicBox);
            this.DynamicBox = skioResponse.DynamicBox;
            this.sellingPlans = Object.entries(this.DynamicBox.sellingPlanGroup).map(([key, value]) => ({
                planId: key,
                ...value
            }));
            this._renderSellingPlans();
            this._renderThresholds(this.DynamicBox.percentDiscountTier);
            this.saleSubscriptionPercent = this.sellingPlans[0].priceAdjustmentAmount;
        }

        $(".js-add-to-bundle, .product-link").on('click', (e) => {
            console.log("Add to bundle clicked");
            e.preventDefault();
            const currentCard = $(e.target).closest('.product-block');
            
            let bgColor = '';
            const styleAttr = currentCard.attr('style') || '';

            const gradMatch = styleAttr.match(/background-image\s*:\s*(linear-gradient\([^;]+\))/i);
            if (gradMatch) {
                bgColor = gradMatch[1];
            } else {
                const colorMatch = styleAttr.match(/background-color\s*:\s*([^;]+)/i);
                if (colorMatch) {
                    bgColor = colorMatch[1].trim();
                } else {
                    const bgMatch = styleAttr.match(/background\s*:\s*([^;]+)/i);
                    if (bgMatch) {
                        bgColor = bgMatch[1].trim();
                    } else {
                        const computed = currentCard.css('background');
                        bgColor = computed && computed.includes('gradient')
                            ? currentCard.css('background-image')
                            : currentCard.css('background-color');
                    }
                }
            }

            const productId = currentCard.data('product-id');
            console.log("Adding product ID:", productId, "BG:", bgColor);
            this._addSlot(productId, bgColor);
        })

        $(".bundles__select").on('change', function (e) {
            console.log("Bundle select changed:", $(this).val());
            e.preventDefault();
            const currentBtn = $(this);
            const targetContent = $(currentBtn).closest('.bundles').find(".bundles__parts");
            targetContent.find('.bundles__part').hide();
            targetContent.find(`${currentBtn.val()}`).fadeIn();
        })

        $(".bundles__nav").on('click', "a", function (e) {
            console.log("Nav clicked:", $(this).attr('href'));
            e.preventDefault();
            const currentBtn = $(this);
            const currentVal = currentBtn.attr('href');
            const targetContent = $(currentBtn).closest('.bundles').find(".bundles__parts");
            currentBtn.closest('ul').find('a.active').removeClass('active');
            currentBtn.addClass('active');
            if (currentVal.includes('all')) {
                targetContent.find('.bundles__part').fadeIn();
            } else {
                targetContent.find('.bundles__part').hide();
                targetContent.find(`${currentBtn.attr('href')}`).fadeIn();
            }
        })

        $(".bundles__slot").on('click', (e) => {
            console.log("Slot clicked (remove):", e.target);
            this._removeSlot($(e.target).closest('.bundles__slot'));
        })

        $(".bundles__main-header").on('click', function (e) {
            console.log("Bundle header clicked");
            e.preventDefault();
            const currentBtn = $(this);
            currentBtn.toggleClass('state-active');
            $(".bundles__slots-wrap").toggleClass('state-active');
        })

        $('[name="subscription-plan"]').on('change', (e) => {
            console.log("Subscription plan changed:", $(e.target).data('plan-id'));
            this.currentSellingPlan = $(e.target).val();
            this.currentSellingPlanId = $(e.target).data('plan-id');
            this._filterItemsBySellingPlans(this.currentSellingPlan);
        })

        if ($('[name="subscription-plan"]:checked').length) {
            const sellingPlanId = $('[name="subscription-plan"]:checked').data('plan-id');
            console.log("Default subscription plan ID:", sellingPlanId);
            this.currentSellingPlanId = sellingPlanId;
        }

        $('[name="selling-plan"]').on('change', (e) => {
            console.log("Selling flow changed:", $(e.target).val());
            this.sellingFlow = $(e.target).val();
            this._updateThresholds();
            if (this.sellingFlow === 'subscription') {
                $(".bundles__plans").addClass('state-active')
            } else {
                $(".bundles__plans").removeClass('state-active')
            }
        })

        $('.js-add-bundles-to-cart').on('click', (e)=> {
            console.log("Add bundle to cart clicked");
            const sellingPlanId = this.sellingFlow === 'subscription' ? this.currentSellingPlanId : '';
            const items = [];
            const preparedItems = this._prepareItems(this.slots);

            if (!preparedItems.length) {
                console.warn("No prepared items to add to cart");
                return;
            }

            preparedItems.forEach((box, index) => {
                const parts = box.productVariants[0].platformId.split('/');
                const activeVariantId = parts[parts.length - 1];
                const obj = {
                    selling_plan: sellingPlanId,
                    properties: {}
                }
                obj.id = activeVariantId;
                obj.quantity = box.quantity;
                obj.properties['_dynamicBoxIndex'] = 0;
                obj.properties['_dynamicBoxId'] = this.DynamicBox.boxId;
                items.push(obj);
            })

            console.log("Prepared items for checkout:", items);

            const baseUrl = `${Shopify.routes.root}cart/clear?return_to=/cart/add?`;
            const returnPath = "%26return_to=/checkout";
            let itemParams = '';

            items.forEach((item, index) => {
                itemParams += `%26items[${index}][quantity]=${item.quantity}%26items[${index}][selling_plan]=${item.selling_plan}%26items[${index}][id]=${item.id}%26items[${index}][properties][_dynamicBoxId]=${item.properties._dynamicBoxId}%26items[${index}][properties][_dynamicBoxIndex]=0`;
            })

            const magicLink = `${baseUrl}${itemParams}${returnPath}`;
            console.log("Redirecting to:", magicLink);
            window.location.href = magicLink;
        });
    },
};

export default Bundles;

/* -------------------------------------------------
   TAB URL UPDATE (unchanged)
   ------------------------------------------------- */
$(".bundles.template-collection .tabs.bundles__nav li a").click(function(e) {
    console.log("Bundle tab clicked:", $(this).attr("href"));
    var hrefdata = $(this).attr("href");
    var currentUrl = window.location.href.split('#')[0];
    var finalurl = currentUrl + hrefdata;
    console.log("Updating URL:", finalurl);
    history.pushState(null, '', finalurl);
});